import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Spinner } from 'react-bootstrap';

import {
  setMultiselectValue,
  deleteImage,
  setError,
} from '../../actions';

import style from './style.module.scss';

const ImageSelector = ({
  section: {
    options,
    value,
    customIconData,
    customIconIsUploading,
  },
  setMultiselectValueAction,
}) => {
  const hasCustomIconUploaded = customIconData?.srsIconUrl;

  return (
    <div className={style.selectorContainer}>
      <div className={style.optionsGrid}>
        {Object.entries(options).map(([itemVal, { label: itemLabel, imageSrc, isCustom }]) => (
          // eslint-disable-next-line
          <div
            key={itemVal}
            className={classnames(style.selectItem, { [style.customItem]: isCustom })}
            onClick={() => setMultiselectValueAction(itemVal)}
          >
            <span
              className={classnames(
                'selectCircle',
                { active: itemVal === value },
              )}
            />
            {!isCustom && <img src={imageSrc} alt="" />}
            {isCustom && customIconIsUploading && (
              <div className={style.customPlaceholder}>
                <Spinner animation="border" variant="primary" size="sm" />
              </div>
            )}
            {isCustom && !customIconIsUploading && hasCustomIconUploaded && (
              <img src={customIconData.srsIconUrl} alt="Custom icon" />
            )}
            {isCustom && !customIconIsUploading && !hasCustomIconUploaded && (
              <div className={style.customPlaceholder}>
                <span>Upload your own icon</span>
              </div>
            )}
            <strong>{itemLabel}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};

export default connect(
  ({ graphics: { selectedInd, sections } }) => ({ section: sections[selectedInd] }),
  {
    setMultiselectValueAction: setMultiselectValue,
    deleteImageAction: deleteImage,
    setErrorAction: setError,
  },
)(ImageSelector);
